export function getPanelsPath() {
  try {
    return JSON.parse(localStorage.getItem('panelsPath')) || {}
  } catch {
    return {}
  }
}

export function savePath(key, value, keysToRemove) {
  const result = getPanelsPath()
  result[key] = value
  if (keysToRemove.length) {
    keysToRemove.forEach((k) => delete result[k])
  }
  localStorage.setItem('panelsPath', JSON.stringify(result))
}
